module.exports = __webpack_public_path__ + "static/media/W19-0096_56_Burger_Desktop_2396x1473.c463c7c0.jpg";